import React from 'react';

function CornerComp({ cornerHome, event }){

  const customAttributes = {'m-l': 'true'};

  if (cornerHome) {
    return (
      <td>
        <div className="d-flex align-items-center justify-content-center">
          <span className="timeline__icon icon-corner" />
          {' '}
          <span className="w-100">Corner</span>
          {' '}
          <span className="timeline__min">{`${event?.matchMinute}'`}</span>
        </div>
      </td>
    );
  }
  return (
    <>
      <td />
      <td />
      <td>
        <div className="d-flex align-items-center justify-content-center">
          <span className="timeline__min">{`${event?.matchMinute}'`}</span>
          {' '}
          <span className="w-100" {...customAttributes}>Corner</span>
          {' '}
          <span className="timeline__icon icon-corner" />
        </div>
      </td>
    </>
  );
};

export default CornerComp;
